import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createVNode as _createVNode, vModelSelect as _vModelSelect, Fragment as _Fragment, vShow as _vShow, renderList as _renderList, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "pl" }
const _hoisted_2 = { class: "pl-topbar" }
const _hoisted_3 = { class: "pl-sub" }
const _hoisted_4 = { class: "pl-card" }
const _hoisted_5 = { class: "pl-toolbar" }
const _hoisted_6 = { class: "pl-search" }
const _hoisted_7 = { class: "pl-filter pl-filter-wide" }
const _hoisted_8 = { class: "pl-filter" }
const _hoisted_9 = { class: "pl-filter" }
const _hoisted_10 = { class: "pl-filter pl-date" }
const _hoisted_11 = { class: "pl-date-pop" }
const _hoisted_12 = {
  key: 1,
  class: "pl-empty"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = ["role", "tabindex", "onClick", "onKeydown"]
const _hoisted_15 = { class: "pl-product" }
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "pl-name" }
const _hoisted_18 = { class: "pl-muted" }
const _hoisted_19 = {
  class: "pl-muted",
  "data-label": "Référence"
}
const _hoisted_20 = {
  class: "num",
  "data-label": "En stock"
}
const _hoisted_21 = {
  class: "num",
  "data-label": "Pas encore reçu"
}
const _hoisted_22 = {
  class: "pl-status",
  "data-label": "Statut"
}
const _hoisted_23 = {
  key: 0,
  class: "pl-muted"
}
const _hoisted_24 = { class: "pl-go" }
const _hoisted_25 = ["disabled", "onClick"]
const _hoisted_26 = {
  key: 0,
  class: "pl-variants"
}
const _hoisted_27 = { class: "pl-vname" }
const _hoisted_28 = { class: "pl-vtext" }
const _hoisted_29 = {
  key: 0,
  class: "pl-pill arch"
}
const _hoisted_30 = {
  class: "pl-muted",
  "data-label": "Référence"
}
const _hoisted_31 = {
  class: "num",
  "data-label": "En stock"
}
const _hoisted_32 = {
  class: "num",
  "data-label": "Pas encore reçu"
}
const _hoisted_33 = {
  key: 0,
  class: "warn"
}
const _hoisted_34 = {
  key: 1,
  class: "zero"
}
const _hoisted_35 = { class: "pl-go" }
const _hoisted_36 = ["disabled", "onClick"]
const _hoisted_37 = {
  key: 3,
  class: "pl-legend"
}
const _hoisted_38 = { key: 0 }
const _hoisted_39 = {
  key: 4,
  class: "pl-footer"
}
const _hoisted_40 = { class: "pl-muted" }
const _hoisted_41 = { class: "pl-pager" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_MyDateRangePicker = _resolveComponent("MyDateRangePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "pl-title" }, "Produits", -1)),
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.filter.total) + " produit(s)", 1)
      ]),
      (_ctx.auth.can('STOCK'))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/add-product",
            class: "pl-btn pl-btn-primary"
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("+ Nouveau produit", -1)
            ])),
            _: 1,
            __: [13]
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[14] || (_cache[14] = _createElementVNode("i", { class: "flaticon-search-interface-symbol" }, null, -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            type: "search",
            placeholder: "Rechercher un produit...",
            "aria-label": "Rechercher un produit",
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          (_ctx.searchTerm)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "pl-clear",
                "aria-label": "Effacer",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearSearch && _ctx.clearSearch(...args)))
              }, "×"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_select, {
            modelValue: _ctx.client_filter,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.client_filter) = $event)),
            class: "custom-select-height",
            label: "name",
            placeholder: "Magasin",
            options: _ctx.clientList,
            onSearch: _ctx.filterClients
          }, null, 8, ["modelValue", "options", "onSearch"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_v_select, {
            modelValue: _ctx.agency_filter,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.agency_filter) = $event)),
            class: "custom-select-height",
            label: "name",
            placeholder: "Agence",
            options: _ctx.agenciesList
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.status_filter) = $event)),
            class: "form-select",
            "aria-label": "Statut"
          }, _cache[15] || (_cache[15] = [
            _createElementVNode("option", { value: "" }, "Statut (tous)", -1),
            _createElementVNode("option", { value: "0" }, "Pas encore reçu", -1),
            _createElementVNode("option", { value: "1" }, "Reçu", -1)
          ]), 512), [
            [_vModelSelect, _ctx.status_filter]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            type: "button",
            class: "pl-date-btn",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showCalendar && _ctx.showCalendar(...args)))
          }, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_ctx.selectedDate?.[0]?.format("DD MMM YYYY") || "Date de création") + " ", 1),
              (_ctx.selectedDate?.[1])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" – " + _toDisplayString(_ctx.selectedDate[1].format("DD MMM YYYY")), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-calendar" }, null, -1))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_11, [
            _createVNode(_component_MyDateRangePicker, {
              modelValue: _ctx.selectedDate,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedDate) = $event)),
              enableSecondCalendar: true,
              onOnSelect: _ctx.showCalendar
            }, null, 8, ["modelValue", "onOnSelect"])
          ], 512), [
            [_vShow, _ctx.showCalendarBox]
          ])
        ]),
        (_ctx.hasFilters)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "pl-reset",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.removeFilter && _ctx.removeFilter(...args)))
            }, "Réinitialiser"))
          : _createCommentVNode("", true)
      ]),
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "pl-row pl-head" }, [
        _createElementVNode("span", null, "Produit / variante"),
        _createElementVNode("span", null, "Référence"),
        _createElementVNode("span", { class: "num" }, "En stock"),
        _createElementVNode("span", { class: "num" }, "Pas encore reçu"),
        _createElementVNode("span", null, "Statut"),
        _createElementVNode("span")
      ], -1)),
      (_ctx.isLoader && !_ctx.rows.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (n) => {
            return _createElementVNode("div", {
              key: 's' + n,
              class: "pl-row pl-skeleton"
            }, _cache[17] || (_cache[17] = [
              _createElementVNode("div", { class: "pl-product" }, [
                _createElementVNode("div", { class: "pl-thumb sk" }),
                _createElementVNode("div", { class: "sk sk-line" })
              ], -1)
            ]))
          }), 64))
        : (!_ctx.rows.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("img", {
                src: require('@/assets/images/NoImage.png'),
                alt: "",
                width: "56"
              }, null, 8, _hoisted_13),
              _cache[18] || (_cache[18] = _createElementVNode("b", null, "Aucun produit trouvé", -1)),
              (_ctx.hasFilters)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "pl-btn pl-btn-ghost",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeFilter && _ctx.removeFilter(...args)))
                  }, "Réinitialiser les filtres"))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 2,
              class: _normalizeClass({ 'pl-dim': _ctx.isLoader })
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: row.id,
                  class: "pl-group"
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["pl-row pl-product-row", { clickable: _ctx.auth.can('STOCK') }]),
                    role: _ctx.auth.can('STOCK') ? 'link' : undefined,
                    tabindex: _ctx.auth.can('STOCK') ? 0 : undefined,
                    onClick: ($event: any) => (_ctx.openProduct(row.id)),
                    onKeydown: _withKeys(($event: any) => (_ctx.openProduct(row.id)), ["enter"])
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("img", {
                        class: "pl-thumb",
                        src: row.pic || require('@/assets/images/NoImage.png'),
                        alt: ""
                      }, null, 8, _hoisted_16),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("b", null, _toDisplayString(row.name), 1),
                        _createElementVNode("span", _hoisted_18, [
                          _createTextVNode(_toDisplayString(row.magasin?.name || row.customer_name || "—") + " ", 1),
                          (row.stock_agency_name)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · " + _toDisplayString(row.stock_agency_name), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.hasVariants(row) ? `${row.inventories.length} variantes` : row.inventories?.[0]?.inventory_ref || "—"), 1),
                    _createElementVNode("div", _hoisted_20, [
                      (_ctx.hasVariants(row))
                        ? (_openBlock(), _createElementBlock("b", {
                            key: 0,
                            class: _normalizeClass({ zero: _ctx.totals(row).stock === 0 })
                          }, _toDisplayString(_ctx.totals(row).stock), 3))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(["pl-qty", _ctx.productLevel(row)])
                          }, _toDisplayString(_ctx.totals(row).stock), 3))
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("b", {
                        class: _normalizeClass(_ctx.totals(row).pending ? 'warn' : 'zero')
                      }, _toDisplayString(_ctx.totals(row).pending || "–"), 3)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["pl-pill", row.received == 1 ? 'ok' : 'wait'])
                      }, _toDisplayString(row.received == 1 ? "Reçu" : "En attente"), 3),
                      (row.received_time)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "le " + _toDisplayString(_ctx.getDate(row.received_time)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      (!_ctx.hasVariants(row) && row.inventories?.[0] && _ctx.canToggleArchive(row.inventories[0]))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "pl-archive",
                            disabled: _ctx.archiving === row.inventories[0].id,
                            onClick: _withModifiers(($event: any) => (_ctx.toggleArchive(row.inventories[0])), ["stop"])
                          }, _toDisplayString(row.inventories[0].archived == 1 ? "Désarchiver" : "Archiver"), 9, _hoisted_25))
                        : _createCommentVNode("", true),
                      (_ctx.auth.can('STOCK'))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "pl-edit" }, "Modifier", -1)),
                            _cache[20] || (_cache[20] = _createElementVNode("span", { "aria-hidden": "true" }, "›", -1))
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ], 42, _hoisted_14),
                  (_ctx.hasVariants(row))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.inventories, (v) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: v.id,
                            class: _normalizeClass(["pl-row pl-variant-row", { archived: v.archived == 1 }])
                          }, [
                            _createElementVNode("span", _hoisted_27, [
                              _cache[21] || (_cache[21] = _createElementVNode("span", {
                                class: "pl-branch",
                                "aria-hidden": "true"
                              }, "└", -1)),
                              _createElementVNode("span", _hoisted_28, _toDisplayString(v.var_name || row.name), 1),
                              (v.archived == 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "Archivé"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("span", _hoisted_30, _toDisplayString(v.inventory_ref || "—"), 1),
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["pl-qty", _ctx.stockLevel(v)])
                              }, _toDisplayString(v.qty ?? 0), 3)
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              (Number(v.qty_not_received) > 0)
                                ? (_openBlock(), _createElementBlock("b", _hoisted_33, "+" + _toDisplayString(v.qty_not_received), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_34, "–"))
                            ]),
                            _cache[22] || (_cache[22] = _createElementVNode("span", null, null, -1)),
                            _createElementVNode("div", _hoisted_35, [
                              (_ctx.canToggleArchive(v))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "pl-archive",
                                    disabled: _ctx.archiving === v.id,
                                    onClick: ($event: any) => (_ctx.toggleArchive(v))
                                  }, _toDisplayString(v.archived == 1 ? "Désarchiver" : "Archiver"), 9, _hoisted_36))
                                : _createCommentVNode("", true)
                            ])
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ], 2)),
      (_ctx.rows.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _cache[24] || (_cache[24] = _createElementVNode("span", null, [
              _createElementVNode("i", { class: "dot ok" }),
              _createTextVNode("En stock")
            ], -1)),
            _createElementVNode("span", null, [
              _cache[23] || (_cache[23] = _createElementVNode("i", { class: "dot low" }, null, -1)),
              _createTextVNode("Stock faible (≤ " + _toDisplayString(_ctx.LOW_STOCK) + ")", 1)
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("span", null, [
              _createElementVNode("i", { class: "dot out" }),
              _createTextVNode("Rupture")
            ], -1)),
            _cache[26] || (_cache[26] = _createElementVNode("span", null, [
              _createElementVNode("i", { class: "dot arch" }),
              _createTextVNode("Archivé (hors total)")
            ], -1)),
            (_ctx.auth.can('STOCK'))
              ? (_openBlock(), _createElementBlock("span", _hoisted_38, "Seule une variante à 0 peut être archivée."))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.filter.total > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _createElementVNode("span", _hoisted_40, _toDisplayString((_ctx.filter.current_page - 1) * _ctx.filter.per_page + 1) + "–" + _toDisplayString(Math.min(_ctx.filter.current_page * _ctx.filter.per_page, _ctx.filter.total)) + " sur " + _toDisplayString(_ctx.filter.total), 1),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.filter.current_page === 1,
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page - 1)))
              }, "‹ Précédent", 8, _hoisted_42),
              _createElementVNode("span", null, "Page " + _toDisplayString(_ctx.filter.current_page) + " / " + _toDisplayString(_ctx.filter.last_page), 1),
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.filter.current_page === _ctx.filter.last_page,
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page + 1)))
              }, "Suivant ›", 8, _hoisted_43)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}